import { GoalText, GoalTextModel } from "./goaltext.model";

export interface GroupGoal {
    id: number;

    goalPeriodId: number;
    goalTextId?: number;
    parentGroupGoalId?: number;
    name: string;

    //clientdata
    employeeName: string;
    parentGroupGoal: GroupGoal;
}

export class GroupGoalModel {
    id = 0;
    
    goalPeriodId = 0;
    goalTextId = null;
    parentGroupGoalId = null;
    name = '';

    //clientdata
    employeeName = '';
    parentGroupGoal: GroupGoal = null;         // for tooltip
}